export default __webpack_public_path__ + "14c9f459cee30bbbbbd7cde0644b545a.png";